import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface IconTextListProps {
  children: ReactNode;
  className?: string;
  small?: boolean;
  fullwidth?: boolean;
  noWrap?: boolean;
  gridClassName?: string;
}

export default function IconTextList({
  children,
  className = "",
  small = false,
  fullwidth = true,
  noWrap = true,
  gridClassName = "",
}: IconTextListProps) {
  const baseClassName = `px-4 md:px-0 background-light ${small ? "py-2" : "py-8"} ${fullwidth ? "fullwidth" : ""}`;
  return (
    <div className={cn(baseClassName, className)}>
      <div className="w-full">
        <div
          className={cn(
            "grid grid-cols-1 lg:grid-cols-2 gap-x-20 gap-y-2 lg:gap-y-4",
            gridClassName,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
